'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapComponent = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// $FlowFixMe
var wrapComponent = exports.wrapComponent = R.useWith(R.when(R.is(String)), [
// $FlowFixMe
R.curry(function (Component, content) {
  return React.createElement(
    Component,
    null,
    content
  );
})]);


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/helpers/wrapComponent.js
// module id = 598
// module chunks = 0